export const API_URL = process.env.REACT_APP_API_URL;

export const fetchWithAuth = async (url, options = {}) => {
  const response = await fetch(url, options);

  if (response.status === 401) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.reload();
    throw new Error('Session expired. Please log in again.');
  }

  return response;
};

// /api/branchesdropdown returns every active branch, unscoped, for every user
// (it's a lightweight global lookup used all over the app — actual per-request
// access is enforced server-side elsewhere). Screens that need to default to
// or restrict selection to the CURRENT user's own branches (e.g. picking a
// starting branch for POS Sales/Shifts) must filter it client-side against
// the user's own allowed_branches from their login payload, same convention
// already used by DailySalesPerShiftReport.
export const filterToUsersOwnBranches = (branches) => {
  try {
    const userData = JSON.parse(localStorage.getItem('user') || '{}');
    if ((userData.role || '').toLowerCase() === 'administrator') return branches;
    const allowedIds = (userData.allowed_branches || []).map(b => Number(b.id));
    return branches.filter(b => allowedIds.includes(Number(b.id)));
  } catch {
    return branches;
  }
};
